import React, { useState } from 'react'
import GradientButton from '../components/GradientButton'
import { useNavigate } from 'react-router-dom'
import { updateCurrentFarm } from '../utils/farmWizard'

const STAGES = ['Hatchery','Nursery','Grow-out','Broodstock','Other']

export default function Stage(){
  const [selected, setSelected] = useState('')
  const [other, setOther] = useState('')
  const navigate = useNavigate()

  function onNext(){
    if(!selected) return alert('Please select a stage')
    updateCurrentFarm((prev) => (
      prev
        ? ({ ...prev, stage: selected === 'Other' ? other : selected } as any)
        : ({ stage: selected === 'Other' ? other : selected } as any)
    ))
    navigate('/production-unit')
  }

  return (
    <div style={{maxWidth:640}}>
      <h2 className="h2">Stage</h2>
      <p className="lead">Select the operational stage for this farm.</p>

      <div className="form-card" style={{marginTop:12}}>
        {STAGES.map(s=> (
          <label key={s} style={{display:'block',padding:8}}>
            <input type="radio" name="stage" value={s} checked={selected===s} onChange={()=>setSelected(s)} /> {s}
          </label>
        ))}

        {selected === 'Other' && (
          <input placeholder="Describe other stage" value={other} onChange={e=>setOther(e.target.value)} />
        )}

        <div style={{marginTop:12}}>
          <GradientButton onClick={onNext}>Next: Production Unit</GradientButton>
        </div>
      </div>
    </div>
  )
}
